// components/utils.js
// Shared utilities extracted from App.jsx
// Usage:
//   import { getIconEl, getDataUrl } from "../components/utils";

import React from "react";
import * as Icons from "@mui/icons-material";

/**
 * Return a Material Icon React element by name (string) with given props.
 * Example: getIconEl("SportsMotorsports", { fontSize: "small", color: "primary" })
 */
export function getIconEl(name, props) {
  if (!name) return null;
  const C = Icons[name];
  return C ? <C {...props} /> : null;
}

/**
 * Build the absolute URL to public/data.json regardless of dev/prod/gh-pages.
 */
export function getDataUrl() {
  const base =
    (typeof import.meta !== "undefined" &&
      import.meta.env &&
      import.meta.env.BASE_URL) ||
    process.env.PUBLIC_URL ||
    "/";
  const normalized = base.endsWith("/") ? base : base + "/";
  return normalized + "data.json";
}
